var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinalize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 101,
    viewBox: "0 0 131 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6235 67.1665L92.0612 68.7633L83.8112 86.6302H47.0854L42.6235 67.1665Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6499 90.985C97.6499 93.7041 96.3192 96.1745 72.6337 92.981C48.1499 94.5778 32.1821 93.7041 32.1821 90.985C32.1821 88.2659 46.8376 86.0616 64.916 86.0616C82.9944 86.0616 97.6499 88.2659 97.6499 90.985Z",
    fill: "#E0DEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7663 13.5224L83.3308 47.853L95.3066 49.9821L107.016 18.5789C104.249 19.6434 100.363 15.6514 98.7663 13.5224Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.69 13.5224C111.69 15.9605 109.143 18.3055 105.494 18.3055C101.846 18.3055 99.2986 15.9605 99.2986 13.5224C99.2986 11.0843 101.846 8.73932 105.494 8.73932C109.143 8.73932 111.69 11.0843 111.69 13.5224Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2.12903
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.324 9.69934L50.7595 44.03L38.7837 46.159L27.074 14.7558C29.8418 15.8203 33.7273 11.8284 35.324 9.69934Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4006 9.6994C22.4006 12.1375 24.9478 14.4825 28.5961 14.4825C32.2445 14.4825 34.7917 12.1375 34.7917 9.6994C34.7917 7.26128 32.2445 4.91632 28.5961 4.91632C24.9478 4.91632 22.4006 7.26128 22.4006 9.6994Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2.12903
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6319 34.1135C93.6319 38.5759 90.8742 42.7535 86.1304 45.8656C81.3958 48.9718 74.7922 50.9278 67.4441 50.9278C60.0961 50.9278 53.4925 48.9718 48.7578 45.8656C44.0141 42.7535 41.2564 38.5759 41.2564 34.1135C41.2564 29.6511 44.0141 25.4735 48.7578 22.3613C53.4925 19.2551 60.0961 17.2992 67.4441 17.2992C74.7922 17.2992 81.3958 19.2551 86.1304 22.3613C90.8742 25.4735 93.6319 29.6511 93.6319 34.1135Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2.12903
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.396 32.0895C63.396 33.3032 62.703 34.4676 61.4501 35.3556C60.1988 36.2425 58.435 36.8122 56.4554 36.8122C54.4757 36.8122 52.712 36.2425 51.4607 35.3556C50.2078 34.4676 49.5148 33.3032 49.5148 32.0895C49.5148 30.8759 50.2078 29.7114 51.4607 28.8234C52.712 27.9366 54.4757 27.3668 56.4554 27.3668C58.435 27.3668 60.1988 27.9366 61.4501 28.8234C62.703 29.7114 63.396 30.8759 63.396 32.0895Z",
    stroke: "black",
    strokeWidth: 1.34934
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0003 32.0895C82.0003 33.3032 81.3072 34.4676 80.0543 35.3556C78.8031 36.2425 77.0393 36.8122 75.0596 36.8122C73.08 36.8122 71.3162 36.2425 70.0649 35.3556C68.812 34.4676 68.119 33.3032 68.119 32.0895C68.119 30.8759 68.812 29.7114 70.0649 28.8234C71.3162 27.9366 73.08 27.3668 75.0596 27.3668C77.0393 27.3668 78.8031 27.9366 80.0543 28.8234C81.3072 29.7114 82.0003 30.8759 82.0003 32.0895Z",
    stroke: "black",
    strokeWidth: 1.34934
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 61.3914,
    y1: 31.7522,
    x2: 69.5652,
    y2: 31.7522,
    stroke: "black",
    strokeWidth: 0.674672
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 41.1812,
    y1: 31.7522,
    x2: 51.4684,
    y2: 31.7522,
    stroke: "black",
    strokeWidth: 0.674672
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0598 31.7521H85.3553L93.0609 27.39",
    stroke: "black",
    strokeWidth: 0.674672
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.075 48.6516L96.0888 79.0453H39.3785L33.883 45.5729L100.075 48.6516Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.12903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.587 64.9404L58.216 69.7308L51.2966 88.892H76.845L72.587 64.9404Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.12903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M88.0259 34.296C89.0669 33.6454 89.544 30.3381 89.6525 28.7657C83.1463 30.067 81.1943 25.35 79.7304 23.7235C78.2665 22.0969 78.7545 21.4463 73.5495 23.7235C68.3445 26.0007 65.5794 23.7235 63.1396 22.5849C60.6998 21.4463 60.0491 24.8621 55.9828 25.35C51.9164 25.838 52.079 21.4463 50.2898 23.7235C40.7908 26.5862 41.3438 23.3981 42.8077 21.4463C42.2655 21.6631 41.1812 21.5439 41.1812 19.3318C44.8246 9.70261 55.9285 12.0665 61.0251 14.4521C61.5672 13.422 63.7251 11.0689 68.0192 9.89776C73.3868 8.43386 71.435 15.5907 83.6341 14.4521C95.8332 13.3135 100.388 18.1932 97.2971 21.4463C94.8248 24.0487 94.4235 26.5428 94.532 27.4645C95.0742 27.6272 96.1587 29.026 96.1587 33.3201C93.7188 40.1516 86.7247 35.1093 88.0259 34.296Z",
    fill: "#1AB7EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3301 43.7471C64.1244 45.2108 70.3121 45.638 73.2754 40.977",
    stroke: "black",
    strokeWidth: 1.35194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalize);
export default __webpack_public_path__ + "static/media/finalize.15ca37b3509ed640debd6031cdc7d84a.svg";
export { ForwardRef as ReactComponent };